import { useFeatures, type WorkspaceFeatures } from "@expert/features";
import { ProductSaleFlow as DecoupledProductSaleFlow } from "@expert/sales-tools";
import { ErrorBoundary } from "react-error-boundary";

import { useLogger } from "@/sdk/logging";

import { ProductSaleFlow } from "./ProductSaleFlow";

export function ProductSaleFlowWrapper() {
    const { features } = useFeatures<WorkspaceFeatures>();
    const logger = useLogger({ module: "ProductSaleFlowWrapper" });

    if (features.isUsingDecoupledSalesComponents) {
        return (
            <ErrorBoundary
                fallback={<ProductSaleFlow />}
                onError={(error) => {
                    logger.error({ error }, "Decoupled ProductSaleFlow crashed, falling back to original");
                }}
            >
                <DecoupledProductSaleFlow />
            </ErrorBoundary>
        );
    }

    return <ProductSaleFlow />;
}
